import {
  delay,
  race,
  select,
  take,
} from 'redux-saga/effects';
import { BOOTSTRAPPING_SUCCESS } from '../actions/user';
import {
  credentialsSelector,
  getUserById,
} from '../selectors/typed/user';
import { rollbar } from '../utils/dev-tools';

/**
 * This method wait for bootstrapping success
 * Only if logged professional
 * It can fallback, if nothing happen after 30s (just continue + rollbar)
 */
export function* awaitBootstrapingIfNecessary() {
  const credentials = yield select(credentialsSelector);
  if (!credentials || Object.keys(credentials).length === 0) {
    return;
  }
  const currentUser = yield select(getUserById());
  if (!currentUser) {
    const { fallback } = yield race({
      bootstrap: take(BOOTSTRAPPING_SUCCESS),
      fallback: delay(30000), // just in case
    });
    if (fallback) {
      rollbar('An user reached the fallback time during wait bootstraping');
    }
  }
}
